export class TokenDTO {
  token: string;

  constructor(value: string) {
    this.token = value;
  }
}
